<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="角色名称">
              <a-input v-model="queryParam.roleName" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="角色代码">
              <a-input v-model="queryParam.roleCode" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button type="primary"@click="() => {this.queryPage()}">查询</a-button>
            <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="$refs.roleAddOrUpdate.init('','add')">新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>
          <!-- lock | unlock -->
          <a-menu-item key="2"><a-icon type="lock" />锁定</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
    <s-table
      bordered
      ref="table"
      :alert="alert"
      :columns="columns"
      :data="loadData"
      :rowKey="record => record.roleId"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="action" slot-scope="text,record">
        <span v-action="'sys:role:update'">
          <a href="javascript:;" @click="edit(record)">编辑</a>
          <a-divider type="vertical" />
        </span>
        <span v-action="'sys:role:del'">
          <a-popconfirm title="是否删除角色" @confirm="deleteItem(record)" okText="是" cancelText="否">
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <a href="javascript:;" style="color: red">删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
        </span>
        <span v-action="'sys:role:info'">
          <a href="javascript:;"@click="show(record)">查看</a>
        </span>
        <span v-action="'sys:role:update'">
          <a href="javascript:;" @click="perms(record)">权限</a>
        </span>
      </span>
    </s-table>
    <role-add-or-update
      ref="roleAddOrUpdate"
      @ok="queryPage"
    />
    <role-perm-modal
      ref="rolePermModal"
    />
  </a-card>

</template>

<script>
import { fetchList, delObj } from '@api/sys/role'
import RoleAddOrUpdate from './roleAddOrUpdate'
import RolePermModal from './rolePermModal'
import { TableMixin } from '@/mixins/TableMixin'
import { DataScopeTypeList as dsTypeList } from '@/dict'
export default {
  name: 'Role',
  mixins: [TableMixin],
  components: {
    RoleAddOrUpdate,
    RolePermModal
  },
  data () {
    return {
      columns: [
        {
          title: '#',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '角色代码',
          dataIndex: 'roleCode'
        },
        {
          title: '角色名称',
          dataIndex: 'roleName'
        },
        {
          title: '数据权限',
          dataIndex: 'dsType',
          customRender: (record) => {
            return (
              <div>
                {
                  dsTypeList.map(item => {
                    if (item.value === record) {
                      return <a-tag color="#108ee9" >{ item.label } </a-tag>
                    }
                  })
                }
              </div>
            )
          }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          customRender: (text, record, index) => {
            return (
              <div>
                <a onClick={(e) => this.edit(record)}
                >修改</a>
                <a-divider type="vertical" />
                <a-popconfirm title="是否删除角色" onConfirm={(e) => this.deleteItem(record)} okText="是" cancelText="否">
                  <a-icon slot="icon" type="question-circle-o" style="color: red" />
                  <a href="javascript:;" style="color: red">删除</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a href="javascript:;"
                  onClick={(e) => this.show(record)}
                >查看</a>
                <a-divider type="vertical" />
                <a href="javascript:;"
                  onClick={(e) => this.perms(record)}
                >权限</a>
              </div>
            )
          }
        }
      ],
      queryParam: {
        roleName: '',
        roleCode: ''
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      }
    }
  },
  methods: {
    edit (record) {
      this.$refs.roleAddOrUpdate.init(record.roleId, 'edit')
    },
    deleteItem (record) {
      delObj(record.roleId).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    },
    show (record) {
      this.$refs.roleAddOrUpdate.init(record.roleId, 'show')
    },
    perms (record) {
      this.$refs.rolePermModal.init(record)
    }
  }
}
</script>

<style scoped>

</style>
